import { ArrowRight } from 'lucide-react';
import { mockData } from '../utils/mock';

export const HowItWorks = () => {
  const { howItWorks } = mockData;

  return (
    <section id="how-it-works" className="py-20 bg-white" aria-labelledby="how-it-works-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 id="how-it-works-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Simple, streamlined process from inquiry to approval
          </p>
        </header>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {howItWorks.map((step, index) => (
              <div key={step.step} className="relative">
                <div className="flex flex-col items-center text-center">
                  {/* Step Number */}
                  <div className="w-20 h-20 bg-blue-900 rounded-full flex items-center justify-center mb-6 relative z-10 shadow-lg" aria-label={`Step ${step.step}`}>
                    <span className="text-3xl font-bold text-white">{step.step}</span>
                  </div>
                  
                  {/* Arrow for mobile */}
                  {index < howItWorks.length - 1 && (
                    <ArrowRight className="lg:hidden text-blue-400 my-4" size={32} aria-hidden="true" />
                  )}

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
